import { Pipe, PipeTransform } from "@angular/core";
import { OperandType, OperatorType } from "./category-builder.models";

@Pipe({
  name: "expressionLabel",
  standalone: false,
})
export class ExpressionLabelPipe implements PipeTransform {
  PLURAL = "plural";
  SINGULAR = "singular";

  transform(
    value: OperatorType | OperandType,
    plurality: string = this.SINGULAR,
  ): string {
    switch (plurality) {
      case this.PLURAL:
        return this.plural(value);
      case this.SINGULAR:
        return this.singular(value);
      default:
        return value;
    }
  }

  plural(value: OperatorType | OperandType): string {
    switch (value) {
      case OperandType.LEMMA:
        return "Lemmas";
      case OperandType.TOKEN:
        return "Tokens";
      case OperandType.ENTITY:
        return "Entities";
      case OperandType.NGRAM:
        return "N-grams";
      case OperandType.QUERY:
        return "Queries";
      case OperandType.PHRASE_GROUP:
        return "Phrase Groups";
      case OperandType.PHRASE:
        return "Phrases";
      case OperandType.CATEGORY_REFERENCE:
        return "Category References";
      case OperandType.EMITTER_ROLE:
        return "Emitter Roles";
      case OperandType.EMITTER:
        return "Emitters";
      case OperandType.EFFORT:
        return "Effort Statements";
      case OperandType.FLUFF:
        return "Fluff Statements";
      case OperandType.SEGMENT:
        return "Segments";
      case OperandType.TOKEN_DEPENDENCY:
        return "Dependencies";
      default:
        return value;
    }
  }

  singular(value: OperatorType | OperandType): string {
    switch (value) {
      case OperandType.LEMMA:
        return "Lemma";
      case OperandType.TOKEN:
        return "Token";
      case OperandType.ENTITY:
        return "Entity";
      case OperandType.NGRAM:
        return "N-gram";
      case OperandType.QUERY:
        return "Query";
      case OperandType.PHRASE_GROUP:
        return "Phrase Group";
      case OperandType.PHRASE:
        return "Phrase";
      case OperandType.CATEGORY_REFERENCE:
        return "Category Reference";
      case OperandType.EMITTER_ROLE:
        return "Emitter Role";
      case OperandType.EMITTER:
        return "Emitter";
      case OperandType.EFFORT:
        return "Effort Statement";
      case OperandType.FLUFF:
        return "Fluff Statement";
      case OperandType.SEGMENT:
        return "Segment";
      case OperandType.TOKEN_DEPENDENCY:
        return "Dependency";
      default:
        return value;
    }
  }
}
